import React from 'react';
import PropTypes from 'prop-types';

import { colorGray } from 'styles/layout/colors';

const IconProtectionPlans = ({
  className = '',
  color = colorGray,
  height = 48,
  width = 48,
}) => (
  <svg
    className={className}
    fill="none"
    height={height}
    viewBox="0 0 48 48"
    width={width}
  >
    <path
      d="M10.4695 12.6679C12.7954 12.2615 14.9666 11.5049 16.9833 10.4966C19.2122 9.37164 21.2681 7.93726 23.1285 6.32856C23.632 5.88278 24.3885 5.90247 24.892 6.34825C26.7342 7.95702 28.7692 9.37308 31.0177 10.4965C33.0343 11.5048 35.224 12.2796 37.5708 12.6875C38.2106 12.8042 38.6761 13.3653 38.6761 14.0051C38.6761 20.8674 37.7649 26.1789 35.5556 30.6004C33.345 35.0781 29.8561 38.5683 24.6995 41.8054C24.2537 42.0768 23.6912 42.0571 23.2651 41.7857C18.1279 38.5682 14.6575 35.058 12.4284 30.6005C10.2374 26.1808 9.32617 20.8694 9.32617 14.0052C9.32617 13.3274 9.8296 12.7649 10.4695 12.6679L10.4695 12.6679ZM19.0969 24.3582C18.5738 23.835 18.5738 23.0011 19.0969 22.478C19.62 21.9549 20.4539 21.9549 20.9771 22.478L23.5365 25.0374L28.4415 20.1522C28.9449 19.6291 29.7985 19.6291 30.3216 20.1325C30.825 20.6556 30.8447 21.5092 30.3216 22.0127L24.4871 27.867C23.964 28.3901 23.1104 28.3704 22.6069 27.867L19.0983 24.3584L19.0969 24.3582ZM18.166 12.8619C16.2268 13.8308 14.1721 14.6071 12.001 15.0908C12.098 21.0225 12.9319 25.6363 14.8121 29.4177C16.6922 33.2175 19.658 36.2606 24.0003 39.0913C28.3232 36.2605 31.2889 33.2175 33.1706 29.4177C35.0705 25.6377 35.9044 21.024 36.0014 15.0908C33.8302 14.6056 31.7559 13.8308 29.8166 12.8619C27.7227 11.8157 25.7652 10.5163 24.0005 9.06212C22.2173 10.5162 20.2781 11.8155 18.1659 12.8619H18.166Z"
      fill={color}
    />
  </svg>
);

IconProtectionPlans.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default IconProtectionPlans;
